import { GetAccountsPositionsHistoryResponse } from '@goldwasserexchange/actor/rest-services';
import { AccountDocument } from '../../../accounts/documents/type';
import { AccountHistory } from '../../../accounts/history/type';
import { AccountsOrder } from '../../../accounts';

export const getFileName = (data?: AccountHistory | AccountDocument | AccountsOrder | GetAccountsPositionsHistoryResponse) => data?.['AR_DOC.FILENAME'] ?? null;
